<template>
  <div class="attr-module">
    <template v-if="tplModules && tplModules.length">
      <section>
        <h3>模块组</h3>
        <ul class="tpl-m-list">
          <li class="tpl-m-item" v-for="(item, index) in tplModules" :key="index"
              @click="onTplModuleClick(item)">
            <div class="tmi-body" :class="{'active': currentModule === item}">
              <editor-area :disabled="true" :value="item" :edit="false" :scale="tplModuleScale(item)"></editor-area>
            </div>
            <div class="tmi-footer c-center">
              <p>{{item.width}}x{{item.height}}</p>
              <p>{{item.name}}</p>
            </div>
          </li>
        </ul>
      </section>
      <section v-if="currentModule && currentModule.isModuleGroup">
        <h3>模块组配置</h3>
        <p>
          <el-checkbox v-model="currentModule.edit" :true-label="module_group_edit.two"
                       :false-label="module_group_edit.one">不可编辑(只能替换方案组)
          </el-checkbox>
        </p>
        <p v-if="currentModule.edit !== module_group_edit.two">
          <span>最多组数 </span>
          <el-input-number controls-position="right" :min="1" style="width:100px"
                           v-model="currentModule.maxCount"></el-input-number>
          <el-button style="margin-left: 20px" @click="onRemoveModule">删除模块组</el-button>
        </p>
      </section>
      <section>
        <h3>替换方案</h3>
        <div class="fa-group">
          <template v-for="(item , index) in moduleGroupList">
            <div class="gl-img-box bg-hover" :key="index">
              <span class="del-bg">
                  <div class="template-icon-btn" title="删除方案组">
                        <i class="el-icon-delete del-icon"
                           @click="onDelModuleGroupItem(item, index)"></i>
                  </div>
                  <div class="template-icon-btn" title="设置方案组">
                       <i class="el-icon-setting del-icon"
                          @click="showFaAttrDialog(item)"></i>
                  </div>
              </span>
              <editor-area :value="item.json" :edit="false"
                           :scale="item.scale"></editor-area>
            </div>
            <p class="gl-img-name c-center" :key="`name_${index}`">
              <el-input v-model="item.name" :minlength="1" v-if="glEditableItem === item"
                        @blur="onGlImgNameBlur(item)"></el-input>
              <el-tooltip :key="`gl_${index}`" v-else
                          placement="top"
                          width="200"
                          trigger="hover"
                          content="双击修改名称">
                <span @dblclick="onGlImgNameClick(item)">{{item.name}}</span>
              </el-tooltip>
            </p>
          </template>
          <psd-parsing class="upload-icon" @onCompleted="onModuleUploadCompleted" @onFileChange="onUploadChange"
                       :disabled="moduleUploaderLoading">
            <el-button round type="default"
                       class="upload-btn" icon="el-icon-plus"
                       :disabled="moduleUploaderLoading"
                       :loading="moduleUploaderLoading">上传方案
            </el-button>
          </psd-parsing>
        </div>
      </section>
    </template>
    <div v-else class="noResult c-center" style="margin-top: 40px">
      <img src="img/noResult.png">
      <p class="c-gray">无模块组数据</p>
    </div>
  </div>
</template>
<script>
    import {
        module_group_edit,
        group_type_mk,
    } from '@/const.js';
    import util from '@/util';
    import groupService from '../../../request/service/group-service'
    import editorArea from '../../templateGroup/editor/tpl-editor-area';
    import psdParsing from '../../templateGroup/uploader/psd-parseing-index'

    const scale_w = 300, scale_h = 120;
    export default {
        components: {editorArea, psdParsing},
        props: {
            value: Object,
            tplModules: Array
        },
        data() {
            return {
                module_group_edit,
                moduleUploaderLoading: false,
                moduleGroupList: [],
                glEditableItem: null, // 当前正在编辑的方案组名称对象
            };
        },
        computed: {
            currentModule() {
                let module = this.$store.state.templateGroup.selectedItem;
                if (module && module.isModuleGroup) {
                    return module;
                } else {
                    return {};
                }
            },
            active() {
                return this.$store.state.templateGroup.attrActiveName === '3';
            },
        },
        watch: {
            active(v) {
                if (v) {
                    this.checkFirstModal();
                }
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.getData();
            },
            checkFirstModal() {
                if (this.tplModules && this.tplModules.length > 0) {
                    this.onTplModuleClick(this.tplModules[0]);
                }
            },
            getData() {
                this.moduleKeyList = [];
                let paramsMK = {
                    projectId: this.value.projectId,
                    templateIds: [this.value.id],
                    type: group_type_mk
                }
                groupService.getGroupList(paramsMK).then(({list}) => {
                    if (list && list.length > 0) {
                        list.forEach((item) => {
                            let width = item.json.width;
                            let height = item.json.height;
                            item.scale = util.getScaleWidthAndHeight(scale_w, scale_h, width, height);
                        });
                    }
                    this.moduleGroupList.splice(0, this.moduleGroupList.length);
                    this.moduleGroupList = list;
                });
            },
            tplModuleScale(item) {
                return util.getScaleWidthAndHeight(100, 70, item.width, item.height);
            },
            onModuleUploadCompleted(data) {
                let {projectId, id} = this.value;
                data.projectId = projectId;
                data.templateId = id;
                data.type = group_type_mk;
                this.moduleUploaderLoading = false;
                data.scale = util.getScaleWidthAndHeight(scale_w, scale_h, data.json.width, data.json.height);
                this.moduleGroupList.unshift(data);
                this.save();
            },
            onUploadChange() {
                this.moduleUploaderLoading = true;
            },
            onDelModuleGroupItem(item, index) {
                let {projectId} = this.value;
                groupService.deleteGroups([item.id], projectId).then(() => {
                    this.moduleGroupList.splice(index, 1);
                    this.$message.success('删除成功');
                })
            },
            showFaAttrDialog(item) {
                this.$store.commit("templateGroup/set_attr_tab", '1');
                this.$store.commit('templateGroup/set_global_module', item);
                this.$store.commit('templateGroup/toggle_global_modal_dialog', true);
            },
            save() {
                let cloneData = JSON.parse(JSON.stringify(this.moduleGroupList));
                let {id, projectId} = this.value;
                groupService.addGroup(cloneData, projectId, id).then(() => {
                    this.getData();
                });
            },
            onGlImgNameBlur(item) {
                let name = item.name;
                if (name && name.trim().length > 0) {
                    this.glEditableItem = null;
                    this.save();
                } else {
                    this.messageErrorForFaGroup();
                }
            },
            messageErrorForFaGroup() {
                this.$message.error('方案组名称不能为空')
            },
            onGlImgNameClick(item) {
                if (this.glEditableItem) {
                    this.messageErrorForFaGroup();
                } else {
                    this.glEditableItem = item;
                }
            },
            onTplModuleClick(moduleItem) {
                this.$emit('onItemClick', moduleItem);
            },
            onRemoveModule() {
                let module = this.$store.state.templateGroup.selectedItem;
                let moduleParent = this.getModuleParent(this.value.json, module);
                if(moduleParent){
                    let idx = moduleParent.children.findIndex((item) => {
                        return item === module;
                    });
                    if(idx > -1){
                        moduleParent.children.splice(idx , 1);
                        this.eventBus.$emit('_delModule_attrDialog', module);
                    }
                    this.$emit('onItemClick', null);
                }
            },
            getModuleParent(parent, currentItem){
                let result, children = parent.children;
                for(let i = 0 ; i < children.length ; i++){
                    if(children[i].isModuleGroup && children[i] === currentItem){
                        return parent;
                    } else if(children[i].children){
                        result = this.getModuleParent(children[i], currentItem);
                        if(result) return result;
                    }
                }
            }
        }
    }
</script>